import dictionaryReducer from './dictionary';
import calendarReducer from './calendar';
import bettingReducer from './betting';

const rootReducer = {
  dictionaryReducer,
  calendarReducer,
  bettingReducer,
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js